import React from "react";

const Switch = ({ label, option, checked = false, onChange, type = "switch", disabled = false }) => {
  
  const handleChange = (e) => {
    if (disabled) return; // Prevent state changes when disabled
    onChange(e.target.checked);
  };

  const renderInput = () => {
    switch (type) {
      case "checkbox":
        return (
          <input
            type="checkbox"
            className="custom-checkbox-input hidden cursor-pointer"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled} // Disable input
          />
        );

      case "checkbox-multiple":
        return (
          <input
            type="checkbox"
            className="custom-checkbox-multiple-input hidden cursor-pointer"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled} // Disable input
          />
        );

      case "switch":
      default:
        return (
          <input
            type="checkbox"
            className="custom-switch-input hidden cursor-pointer"
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled} // Disable input
          />
        );

    }
  };

  const renderContainer = () => {
    switch (type) {
      case "checkbox":
        return (
          <div className={`custom-checkbox cursor-pointer ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}>
            {checked && (
              <svg
                className="custom-checkbox-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                ></path>
              </svg>
            )}
          </div>
        );
      case "checkbox-multiple":
        return (
          <div className={`custom-checkbox-multiple cursor-pointer ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}>
            {checked && (
              <svg
                className="custom-checkbox-multiple-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                ></path>
              </svg>
            )}
          </div>
        );
      case "switch":
      default:
        return (
          <div className={`custom-switch ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}>
            <div className="custom-switch-thumb"></div>
          </div>
        );
    }
  };

  return (
    <label className={`flex block text-sm font-bold text-black flex-col ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}>
      {label && <span className="mb-2">{label}</span>}
      {renderInput()}
      {renderContainer()}
      {option && <span className="text-black">{option}</span>}
    </label>
  );
};

export default Switch;